import {CardMedia} from '@mui/material';
import {getCardBackgroundImage} from 'presentation/utils';
import React from 'react';
import {CustomFooterProps} from './types';

export default function CustomFooter({flPlanoIntegrado, planType}: CustomFooterProps) {
	const background = getCardBackgroundImage({
		planType,
		isIntegrated: flPlanoIntegrado,
	});

	return (
		<CardMedia
			sx={{height: 24, borderRadius: '0 0 12px 12px'}}
			image={background}
			title="Tarjeta carteirinha"
		/>
	);
}
